/**
 * sl-yphr: ELSTER Block Component (Doc-View)
 *
 * Renders the ELSTER block in normal document view (inside a note).
 * Shows a compact summary of connected input database.
 * Filing status is now in Prisma (ElsterFiling) — canvas is just a thumbnail.
 */

import { DatabaseTableViewIcon, SendIcon } from '@blocksuite/icons/lit';
import { BlockComponent } from '@blocksuite/std';
import { html } from 'lit';

import type { ElsterBlockModel } from '../schemas/index.js';
import { applyPageModeFilter } from '../utils/page-mode-filter.js';
import * as styles from './elster-block.css.js';

export const AFFINE_ELSTER = 'affine-elster';

export class ElsterBlockComponent extends BlockComponent<ElsterBlockModel> {
  override connectedCallback() {
    super.connectedCallback();

    // Hide canvas ELSTER blocks in page mode
    if (!applyPageModeFilter(this)) return;
  }

  override renderBlock() {
    const model = this.model;
    const title = model.props.title.toString();
    const { inputTableName } = model.props;

    return html`
      <div class=${styles.elsterBlock}>
        <div class=${styles.header}>
          <span class=${styles.icon}>${SendIcon()}</span>
          <span class=${styles.name}>${title}</span>
        </div>

        <div class=${styles.summary}>
          <div class=${styles.summaryRow}>
            <span class=${styles.rowIcon}>${DatabaseTableViewIcon()}</span>
            <span>
              ${inputTableName
                ? `Eingabe: ${inputTableName}`
                : 'Keine Eingabe-Tabelle'}
            </span>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AFFINE_ELSTER]: ElsterBlockComponent;
  }
}
